import React, { useMemo } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import { FormControl, MenuItem, Select } from "@mui/material";
import { CgProfile } from "react-icons/cg";
import { IconContext } from "react-icons";
import MenuIcon from "../../../assets/icons/menuIcon.tsx";
import UserInfoIcon from "../../../assets/icons/userInfoIcon.tsx";
import LogoutIcon from "../../../assets/icons/logoutIcon.tsx";
import ChangePasswordIcon from "../../../assets/icons/changePasswordIcon.tsx";
import useAuth0 from "../../Auth0Provider/use-auth0.ts";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { AppDispatch } from "@store/store.tsx";
import { fetchChangePasswordUrl } from "@store/userSlice.tsx";
import { useHasPolicy } from "@config/useHasPolicy.ts";
import { PolicyEnum } from "@config/policyEnum.ts";
import { NetworkStatusIndicator } from "../Network/NetworkIndicator.tsx";
import UserIconInCircle from "@assets/icons/userIconInCircle.tsx";

interface NavbarProps {
    toggleSidebar: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ toggleSidebar }) => {
    const selectedOption = "";

    const { logout } = useAuth0();
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.user);
    const { hospitalName } = useSelector((state: any) => state.user);
    const navigate = useNavigate();
    const iconContextValue = useMemo(() => ({
        style: { paddingRight: "0.2rem", color: "#000000" }
    }), []);

    const handleChangePassword = () => {
        dispatch(fetchChangePasswordUrl());
    }
    const showChangePassword = useHasPolicy(PolicyEnum.VIEW_CHANGE_PASSWORD);
    const editChangePassword = useHasPolicy(PolicyEnum.EDIT_CHANGE_PASSWORD);

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: "#fff",
                display: "flex",
                height: "70px",
                justifyContent: "center",
                boxShadow: "none",
                borderBottom: "4px solid #A60A30"
            }}
        >
            <Toolbar className="flex flex-row justify-between">
                <Box className="flex flex-row items-center gap-x-6 px-1">
                    <IconButton edge="start" color="inherit" onClick={toggleSidebar}>
                        <MenuIcon />
                    </IconButton>

                    <Box
                        component="img"
                        src="/assets/images/logo.png"
                        alt="logo"
                        sx={{
                            height: "30px",
                            width: "135px",
                        }}
                    />
                </Box>

                <Box className="flex flex-row items-center">
                    <NetworkStatusIndicator />
                    {/* <NotificationIcon/> */}
                    <Box className="hidden md:block">
                        <FormControl
                            size="small"
                            sx={{
                                border: "none",
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                            }}
                        >
                            <Select
                                value={selectedOption}
                                MenuProps={{
                                    autoFocus: false,
                                }}
                                displayEmpty
                                renderValue={(value) =>
                                    value ? (
                                        <>{value}</>
                                    ) : (
                                        <Box display="flex" gap="0.5rem" >
                                            <IconContext.Provider
                                                value={iconContextValue}
                                            
                                            >
                                                <UserIconInCircle size="40" style={{paddingTop:"0.1rem"}}/>
                                            </IconContext.Provider>
                                            <Box>
                                                <Typography
                                                    variant="body1"
                                                    style={{ marginBottom: -4, color: "#000000B2" }}
                                                >
                                                    {user?.firstName} {user?.lastName}
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    style={{ color: "#0000004D" }}
                                                >
                                                    {hospitalName}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )
                                }
                            >
                                <MenuItem onClick={() => navigate(`/userInfo/${user?.userId}`)}>
                                    <UserInfoIcon />
                                    <Typography className="pl-1.5">User Information</Typography>
                                </MenuItem>
                                <MenuItem
                                    value="Logout"
                                    onClick={() =>
                                        logout({
                                            logoutParams: { returnTo: window.location.origin },
                                        })
                                    }
                                >
                                    <LogoutIcon />
                                    <Typography className="pl-1.5">Logout</Typography>
                                </MenuItem>
                                {showChangePassword &&
                                    <MenuItem value="changePassword" onClick={handleChangePassword} disabled={!editChangePassword}>
                                        <ChangePasswordIcon />
                                        <Typography className="pl-1.5">Change Password</Typography>
                                    </MenuItem>}
                            </Select>
                        </FormControl>
                    </Box>
                </Box>
            </Toolbar>

        </AppBar>
    );
};
export default Navbar;
